import { infiniteQueryOptions, useInfiniteQuery } from "@tanstack/react-query";
import api from "~/shared/api/core/api";
import { Params } from "~/shared/api/types/params";
import { createInfinitePaginationConfig } from "~/shared/util/createInfinitePaginationConfig";

const TRACKS_KEYS = {
  all: ["tracks"] as const,
  list: (params: Params) => [...TRACKS_KEYS.all, "list", params] as const,
  filter: (params: Params) => [...TRACKS_KEYS.all, "filter", params] as const,
};

export const TRACKS_QUERIES = {
  infiniteTracksList: (params: { [key: string]: unknown }) => {
    const paginationConfig = createInfinitePaginationConfig(params, 20);

    return infiniteQueryOptions({
      queryFn: async ({ pageParam = 1, signal }) => {
        const response = await api.get(`/tracks`, {
          params: paginationConfig.queryFnParams(pageParam),
          signal,
        });

        return response.data;
      },
      queryKey: TRACKS_KEYS.list({
        params: paginationConfig.keyParams,
      }),
      ...paginationConfig.opts,
    });
  },
};

export function useInfiniteTracksFilter(params: Record<string, unknown>) {
  return useInfiniteQuery(TRACKS_QUERIES.infiniteTracksList(params));
}
